import { createFrontendModule } from '@backstage/frontend-plugin-api';
import catalogPlugin from '@backstage/plugin-catalog/alpha';

export const essityCatalogOverridesModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    catalogPlugin.getExtension('entity-card:catalog/has-components').override({
      factory(originalFactory) {
        return originalFactory({
          params: {
            loader: async () => {
              return import('../components/cards').then(m => (
                <m.EssityHasComponentsCard />
              ));
            },
          },
        });
      },
    }),
    catalogPlugin.getExtension('entity-card:catalog/has-resources').override({
      factory(originalFactory) {
        return originalFactory({
          params: {
            loader: async () => {
              return import('../components/cards').then(m => (
                <m.EssityHasResourcesCard />
              ));
            },
          },
        });
      },
    }),
    catalogPlugin.getExtension('page:catalog').override({
      factory(originalFactory) {
        return originalFactory({
          params: {
            loader: async () => {
              return import('../components/pages').then(m => (
                <m.EssityCatalogPage />
              ));
            },
          },
        });
      },
    }),
  ],
});
